
export const parseBool = (value: string): boolean => {
    return value.toLowerCase() === "true" || parseInt(value) > 0
}
